import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import imageVaslolo from "../../../assets/images/Vaslolo-completo.svg"

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.topRow}`}>
        <div className={styles.brand}><img width="100" src={imageVaslolo} alt="" /></div>

        <nav className={styles.social} aria-label="Redes sociales">
          <Link
            to="https://instagram.com/vaslolo"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </Link>
        </nav>
      </div>

      <div className={`container ${styles.divider}`} />

      <nav className={`container ${styles.nav}`} aria-label="Enlaces del sitio">
        <Link to="/sobre-nosotros">Sobre Nosotros</Link>
        <Link to="/condiciones-legales">Condiciones Legales</Link>
        <Link to="/contacto">Contacto</Link>
      </nav>
    </footer>
  );
}
